// extracted by mini-css-extract-plugin
module.exports = {"industries":"Industries_industries__XoyCp","title":"Industries_title__D1htV","list":"Industries_list__5dYFb"};